/**
 * Valida se é Natal
 */
export const isChristmas = () =>  (parseInt(new Date().toLocaleDateString("pt-br", {month:"numeric"}))) === 12 && (parseInt(new Date().toLocaleDateString("pt-br", {day:"numeric"}))) <= 25